export async function requestMic() {
    if (!navigator.mediaDevices?.getUserMedia) {
        return { stream: null, denied: true, error: "no-getusermedia" };
    }
    try {
        const stream = await navigator.mediaDevices.getUserMedia({
            audio: {
                echoCancellation: false,
                noiseSuppression: false,
                autoGainControl: false,
                channelCount: 1,
            },
            video: false,
        });
        return { stream, denied: false };
    }
    catch (err) {
        return {
            stream: null,
            denied: true,
            error: err instanceof Error ? err.name : "unknown",
        };
    }
}
